import React, { useState, useEffect } from "react";
import algoliasearch from "algoliasearch/lite";

// Redux Store
// import store from "../store/store";
// import { searchQuery } from "../store/actions/jobsActions";

// const SearchIcon = "/images/search-icon.png";
import { InstantSearch } from "react-instantsearch-dom";
import Autocomplete from "./Autocomplete";
import { Col, Row, Button, Spinner } from "reactstrap";

const searchClient = algoliasearch(
  "TYC5NS4XAD",
  "2d41dff06d0f15beed2b4a415dbc05c2"
);

const SearchSection = props => {
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [clear, setClear] = useState(false);

  const searchHandler = e => {
    e.preventDefault();
    setSearch("");
    setClear(true);
    // setLoading(true);
    // store.dispatch(searchQuery(search));

    if (props.searchFilterHandler) props.searchFilterHandler(search);
  };

  useEffect(() => {
    setLoading(props.loading);
  }, [props.loading]);

  return (
    <React.Fragment>
      <form onSubmit={searchHandler}>
        <div className="search-container">
          <Row>
            <Col md={9} style={{ paddingRight: "0px" }}>
              <InstantSearch searchClient={searchClient} indexName="jobs_dev">
                <Autocomplete
                  inputPlaceholder={"Enter Job Title or Keyword"}
                  onChangeQuery={value => {
                    setSearch(value);
                    setClear(false);
                  }}
                  clearSearch={clear}
                />
              </InstantSearch>
            </Col>
            <Col md={3} style={{ paddingLeft: "0px" }}>
              <Button
                color="primary"
                // className="search-btn"
                // disabled={loading}
                onSubmit={searchHandler}
                style={{ height: "2.4rem", borderRadius: "0px" }}
              >
                Search
              </Button>
            </Col>
          </Row>
        </div>
      </form>
    </React.Fragment>
  );
};

export default SearchSection;
